import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { UrlAsObservableService } from '../app-config/url-as-observable.service'
import { UrlCollection } from '../url-collection'

/** This service requests data from the /config branch of the jml-backend. */

// Todo: There are other services that use the config-api. Consolidate those here?
@Injectable({
  providedIn: 'root'
})
export class ConfigApiService {
  constructor(
    private http: HttpClient,
    private urlAsObsService: UrlAsObservableService
  ) {}

  /** returns the welcome text (individually set per client) for the login page. */
  getWelcomeText$ = (): Observable<string> =>
    this.urlAsObsService.Config.WELCOME_TEXT$().pipe(
      switchMap((url) => this.http.get(url, { responseType: 'text' as const }))
    )
}
